export default __webpack_public_path__ + "static/media/transparent_logo.033aff02.png";